module.exports = __webpack_public_path__ + "static/fonts/Fact-Regular.b35e2dd.ttf";